import { Box, Slide } from '@mui/material';
import ActiveOrganizationMenu from '../organizations/active-organization-menu';
import { useState, useEffect } from 'react';
import DashboardButton from '../common/dashboard-button';

type Props = {
  isMobileMenuOpen: boolean;
  onClose: () => void;
};

export default function ActiveOrganization({ isMobileMenuOpen, onClose }: Props) {
  const [open, setOpen] = useState(isMobileMenuOpen);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setOpen(isMobileMenuOpen);
  }, [isMobileMenuOpen]);

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const handleModalOpen = () => {
    setModalOpen(true);
    setOpen(false);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Slide direction="right" in={open && !modalOpen} mountOnEnter unmountOnExit={false} timeout={600}>
        <Box
          sx={{
            position: 'fixed',
            display: open ? 'flex' : 'none',
            flexDirection: 'column',
            top: 16,
            left: 16,
            zIndex: 1300,
            gap: 1.5,
            maxHeight: 'calc(100vh - 32px)',
          }}
        >
          {/* Dashboard Button */}
          <DashboardButton onClick={handleClose} />

          {/* Organization Menu */}
          <Box
            sx={{
              backgroundColor: 'background.paper',
              boxShadow: 6,
              borderRadius: 2,
              overflowY: 'auto',
              maxHeight: 'calc(100vh - 120px)',
            }}
          >
            <ActiveOrganizationMenu
              onMenuItemClick={handleClose}
              onModalOpen={handleModalOpen}
              onModalClose={handleModalClose}
              isModalOpen={modalOpen}
            />
          </Box>
        </Box>
      </Slide>
    </>
  );
}
